// Copyright (c) 2016 Deere & Company

import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import t from 'tcomb';

const Component = t.struct({
    canBeDeleted: t.Bool,
    changedBy: t.maybe(TimestampUser),
    changedDate: t.maybe(t.Number),
    code: t.String,
    createdBy: t.maybe(TimestampUser),
    createdDate: t.maybe(t.Number),
    description: t.String,
    id: t.String,
    isPin: t.Bool,
    partNumber: t.String,
    pin: t.String,
    serialNumber: t.String
}, {
    name: 'Component',
    strict: true
});

export const getDefaultState = () => new Component({
    canBeDeleted: false,
    changedBy: getTimestampUserDefaultState(),
    changedDate: null,
    code: '',
    createdBy: getTimestampUserDefaultState(),
    createdDate: null,
    description: '',
    id: '',
    isPin: false,
    partNumber: '',
    pin: '',
    serialNumber: ''
});

export default Component;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/component.js